import { LitElement, html, css, TemplateResult } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { TerminalInfo } from '../../../src/models/types/terminals-model.types';
import { FiSubView, UiStateModel, UiStateModelParam } from '../../../src/models/ui-state-model';
import { MapView } from '../../voyage-map/src/voyage-map';

interface GroupedTerminals {
    city: string,
    cityId: string,
    terminals: TerminalInfo[]
}

@customElement('voy-map-terminal-tooltip')
export class VoyMapTerminalTooltip extends LitElement {
    @property({type: Boolean}) visible: boolean = false; 
    @property({attribute: false}) groupedTerminals?: GroupedTerminals[];

    constructor() {
        super()

        this._renderGroupedTerminals = this._renderGroupedTerminals.bind(this);
    }

    static get styles() {
        return [ 
            css`
                .tooltip {
                    background: var(--neutrals-grey-02, gray);
                    display: none;
                    color: white;
                    font-family: MaerskText;
                    font-size: 12px;
                    padding: 16px;
                    border-radius: 5px;
                    position: relative;
                    bottom: 12px;
                }
                .tooltip[visible] {
                    display: block;             
                }
                p {
                    margin: 0;
                    padding:0;
                }
                .vessel-title {
                    color: white;
                    font-weight: bold;
                    font-size: 14px;
                    line-height: 12px;
                    font-family: MaerskText;
                    padding: 4px 0px;
                }
                .vessel-title:first-child {
                    padding: 0px 0px 4px 0px;
                }
                .vessel-title:hover {
                    text-decoration: underline;
                    cursor: pointer;
                }
                .list {
                    display: grid;
                    grid-template-columns: auto 3fr;
                    margin-bottom: 7px;
                    gap: 0px 6px
                }
                .list:last-child {
                    margin-bottom: 0;
                }
                .vessel-info{
                    color: white;
                    font-size: 12px;
                    line-height: 20px;
                    font-family: MaerskText;
                }
                .tooltip:after{
                    top: 100%;
                    border: solid transparent;
                    content: " ";
                    height: 0;
                    width: 0;
                    position: absolute;
                }
                .tooltip:after {
                    border-top-color: var(--neutrals-grey-02, gray);
                    border-width: 10px;
                    left: calc(50% - 10px);
                }
            `
        ];
    }
        
    render() {
        return html`
            <div class="tooltip" ?visible=${this.visible}>
                ${this.groupedTerminals?.map(this._renderGroupedTerminals)}
            </div>
        `
    }

    private _renderGroupedTerminals(el:GroupedTerminals) {
        return html`
            <div
                class="vessel-title"
                @click=${() => this._onTerminalClick(el)}>${el.cityId}: ${el.city}
            </div>
            <div class="list">
                ${el.terminals.map(el => this._renderTerminal(el.locationId, el.location))}
            </div>
        `
    }

    private _renderTerminal(id: string, location: string) {
        return html`
            <p class="vessel-info">${id}:</p>
            <p class="vessel-info">${location}</p>
        `
    }

    private _onTerminalClick = (port: GroupedTerminals) => {
        UiStateModel!.setValue(UiStateModelParam.FISubView, FiSubView.PortView);
        UiStateModel!.setValue(UiStateModelParam.PORT, port.cityId);
        
        let coords = port.terminals.map(terminal => {
            return [terminal.longitude, terminal.latitude]
        })

        this.dispatchEvent(new CustomEvent(MapView.AdaptView, {
            detail: coords,
            bubbles: true,
            composed: true,
        }));
    }
};
